


























































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { PostRenkou } from "@/request/hdr";
@Component({})
export default class HdrAnalysisReportRenkou extends Vue {
  @Prop()
  private selectedHospitals: any;
  private message: any = {
    年龄分布: {},
    地区分布: {}
  };
  private xingbiePie: any = {
    tooltip: {},
    color: ["#75DDB5", "#74A0FC"],
    grid: {},
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"],
        center: ["50%", "40%"],
        label: {
          formatter: (params: any) => {
            return params.percent + "%" + "\n" + params.name;
          },
          fontSize: 14
        }
      }
    ]
  };
  /**
   * @description 获得人口统计数据
   */
  private fetchRenkou() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids
    };
    PostRenkou(this, params).then((data: any) => {
      this.message = data;
      console.log(data);
      this.createXingbiePie();
    });
  }
  /**
   * @description 计算背景长度
   */
  private calBackground(item) {
    const style: any = {};
    style.width =
      item.ratio * 0.8 * (this.$refs.zongliang as any).offsetWidth + 40 + "px";
    return style;
  }
  /**
   * @description 创建性别饼图
   */
  private createXingbiePie() {
    this.message["性别分布"]["data"].map((i: any) => {
      i.name = i.title;
    });
    this.xingbiePie.series[0].data = this.message["性别分布"]["data"];
  }
  /**
   * @description 计算地区分布长度
   */
  private calDiquBackground(item) {
    const style: any = {};
    const colorValue = [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      "a",
      "b",
      "c",
      "d",
      "e",
      "f"
    ];
    let s = "#";
    for (let i = 0; i < 6; i++) {
      s += colorValue[Math.floor(Math.random() * 16)];
    }
    if (s === "#ffffff") {
      s = "#000000";
    }
    style.backgroundColor = s;
    style.width =
      item.ratio * 0.8 * (this.$refs.diquChang as any).offsetWidth + 40 + "px";
    return style;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.fetchRenkou();
      },
      {
        immediate: true
      }
    );
  }
}
